import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { BarChart } from '@/features/dashboard-charts';
import type { TopItemsData } from '@/entities/dashboard';

interface TopListsGridProps {
  topWarehouses?: TopItemsData;
  topUsers?: TopItemsData;
  isLoading: boolean;
}

export function TopListsGrid({ topWarehouses, topUsers, isLoading }: TopListsGridProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">{t('welcome.chart.topwarehouses.label', 'Top Warehouses')}</h3>
        <BarChart data={topWarehouses} height={300} loading={isLoading} />
      </Card>

      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">{t('welcome.chart.topusers.label', 'Top Users')}</h3>
        <BarChart data={topUsers} height={300} loading={isLoading} />
      </Card>
    </div>
  );
}
